import { render, staticRenderFns } from "./ConsolidationOrdersModule.vue?vue&type=template&id=b909b320"
import script from "./ConsolidationOrdersModule.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports